import { ApolloClient, ApolloLink, type NormalizedCacheObject } from "@apollo/client";

import { authLink } from "../../apollo/provider";

import { apiLink } from "./apiLink";
import { cache } from "./cache";

let insightApolloClient: ApolloClient<NormalizedCacheObject> | null = null;

export const InsightsApolloClient = (): ApolloClient<NormalizedCacheObject> => {
    if (!insightApolloClient) {
        insightApolloClient = new ApolloClient({
            cache,
            link: ApolloLink.from([authLink, apiLink]),
        });
    }
    return insightApolloClient;
};
